import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { SafeSessionStorage } from '@utils/browser';

import Cookies from 'js-cookie';

const LEAD_TOKEN_KEY = '__clutter:agent_lead_token';

export const TEAL_USER_ID = Cookies.get('teal_user_id');

/**
 * Lead token for agent-assisted booking (Zendesk links include `lead_token`).
 * Prefer the URL over sessionStorage so opening a new customer's link in the
 * same browser tab/session does not keep the previous customer's token.
 */
function resolveAgentBookingLeadToken(search: string): string | undefined {
  if (typeof window === 'undefined') return undefined;

  const fromUrl = new URLSearchParams(search).get('lead_token');
  const fromStorage = SafeSessionStorage.getItem(LEAD_TOKEN_KEY);
  const token = (fromUrl ?? fromStorage) || undefined;

  if (token) {
    SafeSessionStorage.setItem(LEAD_TOKEN_KEY, token);
  }

  return token;
}

export function useAgentBookingLeadToken(): string | undefined {
  const { search } = useLocation();
  return useMemo(() => resolveAgentBookingLeadToken(search), [search]);
}
